(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azor-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.azor-tm').forEach(function(sec){
    var slides=sec.querySelectorAll('.azor-tm-slide');
    var dots=sec.querySelectorAll('.azor-tm-dot');
    if(slides.length<2)return;
    function go(i){
      slides.forEach(function(s){s.classList.remove('active')});
      dots.forEach(function(d){d.classList.remove('active')});
      slides[i].classList.add('active');dots[i].classList.add('active');
    }
    dots.forEach(function(d){d.addEventListener('click',function(){go(parseInt(d.dataset.go))})});
    var idx=0;setInterval(function(){idx=(idx+1)%slides.length;go(idx)},6000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
